import styled from '@emotion/styled';

export const SectionWrapperBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
`;

export const SectionTitle = styled.h1`
  margin-bottom: 1rem;
  padding: 0;
  font-size: 1.5rem;
`;
